import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SanitizedLabel from 'ContentComponents/cmv2/SanitizedLabel';
import HelpTooltip from 'ContentComponents/cmv2/HelpTooltip';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIToggle from 'UIComponents/input/UIToggle';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LABEL_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};
class BooleanField extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = e => {
      const {
        onFieldChange
      } = this.props;
      onFieldChange(e.target.checked);
    };
  }
  renderLabel() {
    const {
      _label: label,
      helpText,
      labelPosition
    } = this.props;
    if (!label) return null;
    const labelClassName = classNames('p-right-2', labelPosition === LABEL_POSITIONS.RIGHT && 'm-left-5', labelPosition === LABEL_POSITIONS.LEFT && !helpText && 'm-right-2');
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        className: labelClassName,
        children: /*#__PURE__*/_jsx(SanitizedLabel, {
          label: label
        })
      }), helpText && /*#__PURE__*/_jsx("span", {
        className: "p-right-2 p-top-1",
        children: /*#__PURE__*/_jsx(HelpTooltip, {
          title: helpText
        })
      })]
    });
  }
  render() {
    const {
      _isReadOnly: isReadOnly,
      fieldKey,
      labelPosition,
      readOnly,
      tooltipText,
      value
    } = this.props;
    const checked = typeof value === 'string' ? value === 'true' : value;
    return /*#__PURE__*/_jsxs("div", {
      children: [labelPosition === LABEL_POSITIONS.LEFT && this.renderLabel(), /*#__PURE__*/_jsx(UITooltip, {
        disabled: !tooltipText,
        placement: "right",
        title: tooltipText,
        children: /*#__PURE__*/_jsx(UIToggle, {
          "data-selenium": fieldKey && fieldKey.join('.'),
          checked: checked,
          disabled: isReadOnly,
          onChange: this.onChange,
          readOnly: readOnly,
          size: "extra-small"
        })
      }), labelPosition === LABEL_POSITIONS.RIGHT && this.renderLabel()]
    });
  }
}
BooleanField.propTypes = {
  _isReadOnly: PropTypes.bool,
  _label: PropTypes.string,
  fieldKey: PropTypes.array.isRequired,
  helpText: PropTypes.node,
  labelPosition: PropTypes.node,
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  tooltipText: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};
BooleanField.defaultProps = {
  labelPosition: LABEL_POSITIONS.LEFT
};
export default BooleanField;